<template>
  <div class="disk-scene">
  <div class="disk-terminal">
    <div class="terminal-bar">
      <span class="terminal-dots" aria-hidden="true"><i></i><i></i><i></i></span>
      <span class="terminal-name">equinix-1</span>
    </div>
    <div class="terminal-screen">
      <h2 class="terminal-title">[user@equinix-1 /]$</h2>
      <div class="command-line">
        <span>parted -s</span>
        <v-select
          v-model="c1Opt1"
          :options="options"
          placeholder="Select Option"
          class="cmd-select"
          append-to-body
          :calculate-position="placeMenu"
          :class="{ correct: isCorrect.c1Opt1, incorrect: isCorrect.c1Opt1 === false }"
        />
        <v-select
          v-model="c1Opt2"
          :options="options"
          placeholder="Select Option"
          class="cmd-select"
          append-to-body
          :calculate-position="placeMenu"
          :class="{ correct: isCorrect.c1Opt2, incorrect: isCorrect.c1Opt2 === false }"
        />
        <span>gpt</span>
      </div>
      <div class="command-line">
        <span>parted -s</span>
        <v-select
          v-model="c2Opt1"
          :options="options"
          placeholder="Select Option"
          class="cmd-select"
          append-to-body
          :calculate-position="placeMenu"
          :class="{ correct: isCorrect.c2Opt1, incorrect: isCorrect.c2Opt1 === false }"
        />
        <v-select
          v-model="c2Opt2"
          :options="options"
          placeholder="Select Option"
          class="cmd-select"
          append-to-body
          :calculate-position="placeMenu"
          :class="{ correct: isCorrect.c2Opt2, incorrect: isCorrect.c2Opt2 === false }"
        />
        <v-select
          v-model="c2Opt3"
          :options="options"
          placeholder="Select Option"
          class="cmd-select"
          append-to-body
          :calculate-position="placeMenu"
          :class="{ correct: isCorrect.c2Opt3, incorrect: isCorrect.c2Opt3 === false }"
        />
        <v-select
          v-model="c2Opt4"
          :options="options"
          placeholder="Select Option"
          class="cmd-select"
          append-to-body
          :calculate-position="placeMenu"
          :class="{ correct: isCorrect.c2Opt4, incorrect: isCorrect.c2Opt4 === false }"
        />
        <span>1 10G</span>
      </div>
      <div class="command-line">
        <span>mkfs.</span>
        <v-select
          v-model="c3Opt1"
          :options="options"
          placeholder="Select Option"
          class="cmd-select"
          append-to-body
          :calculate-position="placeMenu"
          :class="{ correct: isCorrect.c3Opt1, incorrect: isCorrect.c3Opt1 === false }"
        />
        <v-select
          v-model="c3Opt2"
          :options="options"
          placeholder="Select Option"
          class="cmd-select"
          append-to-body
          :calculate-position="placeMenu"
          :class="{ correct: isCorrect.c3Opt2, incorrect: isCorrect.c3Opt2 === false }"
        />
      </div>
    </div>
  </div>

  <section class="dc-diagram" aria-label="Equinix data center tree">
    <p class="dc-label">Data center tree</p>
    <svg class="net-svg" viewBox="0 0 900 320" role="img">
      <title>Network path from the internet to the new drive in equinix-1</title>
      <g fill="none" stroke="#3d4c63" stroke-width="1.5">
        <line x1="136" y1="36" x2="176" y2="36" />
        <line x1="276" y1="36" x2="316" y2="36" />
        <line x1="456" y1="68" x2="456" y2="96" />
        <line x1="526" y1="120" x2="566" y2="120" />
        <line x1="636" y1="144" x2="636" y2="168" />
        <line x1="160" y1="168" x2="760" y2="168" />
        <line x1="160" y1="168" x2="160" y2="196" />
        <line x1="460" y1="168" x2="460" y2="196" />
        <line x1="760" y1="168" x2="760" y2="196" />
        <line x1="460" y1="248" x2="460" y2="272" stroke="#7dcea0" />
      </g>
      <g font-family="Fira Code, ui-monospace, SFMono-Regular, Menlo, Consolas, monospace" text-anchor="middle">
        <rect x="16" y="12" width="120" height="48" rx="6" fill="#12161c" stroke="#3d4c63" />
        <text x="76" y="41" fill="#e7eef8" font-size="15">Internet</text>

        <rect x="176" y="12" width="100" height="48" rx="6" fill="#12161c" stroke="#3d4c63" />
        <text x="226" y="41" fill="#e7eef8" font-size="15">ISP</text>

        <rect x="316" y="8" width="280" height="60" rx="6" fill="#12161c" stroke="#3d4c63" />
        <text x="456" y="32" fill="#e7eef8" font-size="15">Equinix DC11</text>
        <text x="456" y="52" fill="#8b98ab" font-size="12">21715 Filigree Ct, Ashburn, VA</text>

        <rect x="386" y="96" width="140" height="48" rx="6" fill="#12161c" stroke="#3d4c63" />
        <text x="456" y="125" fill="#e7eef8" font-size="15">Cage C-14</text>

        <rect x="566" y="96" width="140" height="48" rx="6" fill="#12161c" stroke="#3d4c63" />
        <text x="636" y="125" fill="#e7eef8" font-size="15">Rack A12</text>

        <rect x="90" y="196" width="140" height="52" rx="6" fill="#12161c" stroke="#3d4c63" />
        <text x="160" y="227" fill="#e7eef8" font-size="15">equinix-2</text>

        <rect x="390" y="196" width="140" height="52" rx="6" fill="#12161c" stroke="#7dcea0" />
        <text x="460" y="218" fill="#7dcea0" font-size="15">equinix-1</text>
        <text x="460" y="236" fill="#8b98ab" font-size="12">server node</text>

        <rect x="690" y="196" width="140" height="52" rx="6" fill="#12161c" stroke="#3d4c63" />
        <text x="760" y="227" fill="#e7eef8" font-size="15">equinix-3</text>

        <rect x="390" y="272" width="140" height="40" rx="6" fill="#12161c" stroke="#7dcea0" />
        <text x="460" y="297" fill="#7dcea0" font-size="15">new drive</text>
      </g>
    </svg>
  </section>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  data() {
    return {
      isLogPopupVisible: false,
      options: [
        '/dev/sdc',
        'mklabel',
        'lsblk',
        'primary',
        'parted',
        '/dev/dev1',
        'ext3',
        'mkdir',
        'gpt',
        'secondary',
        'sdc',
        'sdb',
        'ext2',
        '/dev/sdc1',
        '/data',
        'mkpart',
        'ext4',
      ],
      c1Opt1: '',
      c1Opt2: '',
      c2Opt1: '',
      c2Opt2: '',
      c2Opt3: '',
      c2Opt4: '',
      c3Opt1: '',
      c3Opt2: '',
      isCorrect: {
        c1Opt1: null,
        c1Opt2: null,
        c2Opt1: null,
        c2Opt2: null,
        c2Opt3: null,
        c2Opt4: null,
        c3Opt1: null,
        c3Opt2: null,
      },
    };
  },
  methods: {
    showLogPopup() {
      this.isLogPopupVisible = true;
    },
    placeMenu(menu, _component, { width, top, left }) {
      menu.classList.add('disk-eq-menu');
      menu.style.position = 'absolute';
      menu.style.width = width;
      menu.style.top = top;
      menu.style.left = left;
      menu.style.zIndex = '100000';
    },
    markSimulation() {
      let totalScore = 0;

      // Grade first command
      this.isCorrect.c1Opt1 = this.c1Opt1 === '/dev/sdc';
      if (this.isCorrect.c1Opt1) {
        totalScore++;
      }

      this.isCorrect.c1Opt2 = this.c1Opt2 === 'mklabel';
      if (this.isCorrect.c1Opt2) {
        totalScore++;
      }

      // Grade second command
      this.isCorrect.c2Opt1 = this.c2Opt1 === '/dev/sdc';
      if (this.isCorrect.c2Opt1) {
        totalScore++;
      }

      this.isCorrect.c2Opt2 = this.c2Opt2 === 'mkpart';
      if (this.isCorrect.c2Opt2) {
        totalScore++;
      }

      this.isCorrect.c2Opt3 = this.c2Opt3 === 'primary';
      if (this.isCorrect.c2Opt3) {
        totalScore++;
      }

      this.isCorrect.c2Opt4 = this.c2Opt4 === 'ext4';
      if (this.isCorrect.c2Opt4) {
        totalScore++;
      }

      // Grade third command
      this.isCorrect.c3Opt1 = this.c3Opt1 === 'ext4';
      if (this.isCorrect.c3Opt1) {
        totalScore++;
      }

      this.isCorrect.c3Opt2 = this.c3Opt2 === '/dev/sdc1';
      if (this.isCorrect.c3Opt2) {
        totalScore++;
      }

      if (totalScore === 8) {
        this.$emit('simulation_full_correct', totalScore);
      } else {
        this.$emit('simulation_getting_there', totalScore);
      }
    },
  },
  components: {
    vSelect,
  },
};
</script>

<style lang="scss" scoped>
.disk-scene {
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  width: 100%;
}

.dc-diagram {
  margin-top: 1.5rem;
  padding: 0.75rem;
  border: 1px solid #2a3140;
  border-radius: 0.75rem;
  background: #0e1116;
}

.dc-label {
  margin: 0 0 0.75rem;
  color: #c5d0de;
  font-family: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 0.95rem;
}

.net-svg {
  display: block;
  width: 100%;
  height: auto;
}

.disk-terminal {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  overflow: hidden;
  border: 1px solid #2a3140;
  border-radius: 0.75rem;
  background: #0e1116;
  color: #e7eef8;
  font-family: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}

.terminal-bar {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 2.75rem;
  padding: 0.5rem 0.9rem;
  background: #1a1f27;
  border-bottom: 1px solid #2a3140;
}

.terminal-dots {
  display: inline-flex;
  gap: 0.35rem;

  i {
    width: 0.65rem;
    height: 0.65rem;
    border-radius: 999px;
    background: #3a4250;
    display: block;
  }
}

.terminal-name,
.terminal-title,
.command-line {
  font-family: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}

.terminal-name {
  color: #c5d0de;
  font-size: 1.2rem;
}

.terminal-screen {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 1.35rem;
  padding: 1.5rem 1.25rem 2rem;
  overflow: visible;
}

.terminal-title {
  margin: 0;
  color: #7dcea0;
  font-size: 1.5rem;
  font-weight: 600;
}

.command-line {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.45rem 0.55rem;
  color: #e7eef8;
  font-size: 1.15rem;
  line-height: 1.3;
  white-space: nowrap;
}

.cmd-select {
  flex: 0 0 auto;
  width: 10.75rem;
  min-width: 10.75rem;
  max-width: 10.75rem;
}

.disk-terminal .cmd-select ::v-deep .vs__dropdown-toggle,
.disk-terminal .cmd-select ::v-deep .vs__selected-options,
.disk-terminal .cmd-select ::v-deep .vs__search,
.disk-terminal .cmd-select ::v-deep .vs__actions {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

.disk-terminal .cmd-select ::v-deep .vs__dropdown-toggle {
  width: 100%;
  min-width: 0;
  min-height: 0;
  padding: 0 2px 0 8px !important;
  border: 1px solid #3d4c63;
  border-radius: 0.35rem;
}

.cmd-select ::v-deep .vs__selected-options {
  flex: 1 1 auto;
  width: auto;
  min-width: 0;
  padding: 0;
  flex-wrap: nowrap;
  overflow: hidden;
}

.disk-terminal .cmd-select ::v-deep .vs__selected-options .vs__selected,
.cmd-select ::v-deep .vs__selected {
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  background-color: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  color: #e7eef8 !important;
  font-family: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace !important;
  font-size: 1.15rem !important;
  font-weight: 400 !important;
  line-height: 1.3 !important;
  white-space: nowrap;
}

.cmd-select ::v-deep .vs__search {
  flex: 1 1 auto;
  width: 0;
  min-width: 0;
  margin: 0;
  padding: 0;
  color: #e7eef8;
  font-family: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 1.15rem;
  line-height: 1.3;
}

.cmd-select ::v-deep .vs__search::placeholder {
  color: #8b98ab;
}

.cmd-select ::v-deep .vs--has-value .vs__search {
  width: 0;
  padding: 0;
  margin: 0;
}

.cmd-select ::v-deep .vs__actions {
  padding: 0;
}

.disk-terminal .cmd-select ::v-deep .vs__actions,
.disk-terminal .cmd-select ::v-deep .vs__clear,
.disk-terminal .cmd-select ::v-deep .vs__open-indicator {
  padding: 0 0 0 2px !important;
  margin: 0 !important;
  background: transparent !important;
  background-color: transparent !important;
  color: #e7eef8 !important;
  fill: #e7eef8 !important;
  font-family: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace !important;
  font-size: 1.15rem !important;
  line-height: 1;
}

.disk-terminal .cmd-select ::v-deep .vs__clear svg,
.disk-terminal .cmd-select ::v-deep .vs__open-indicator svg,
.disk-terminal .cmd-select ::v-deep .vs__clear svg path,
.disk-terminal .cmd-select ::v-deep .vs__open-indicator svg path {
  fill: #e7eef8 !important;
  stroke: #e7eef8 !important;
}

.cmd-select ::v-deep .vs__dropdown-menu {
  margin-top: 4px;
  padding: 4px 0;
  background: #12161c;
  border: 1px solid #3d4c63;
}

.cmd-select ::v-deep .vs__dropdown-option,
.cmd-select ::v-deep .vs__dropdown-option--highlight,
.cmd-select ::v-deep .vs__dropdown-option--selected {
  padding: 4px 8px;
  background: transparent !important;
  background-color: transparent !important;
  color: #e7eef8 !important;
  font-family: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 1.15rem;
  line-height: 1.3;
  white-space: nowrap;
}

.cmd-select.correct ::v-deep .vs__dropdown-toggle {
  border-color: #28a745;
}

.cmd-select.correct ::v-deep .vs__selected {
  color: #e7eef8 !important;
  font-size: 1.15rem !important;
  background: transparent !important;
  background-color: transparent !important;
}

.cmd-select.incorrect ::v-deep .vs__dropdown-toggle {
  border-color: #dc3545;
}

.cmd-select.incorrect ::v-deep .vs__selected {
  color: #e7eef8 !important;
  font-size: 1.15rem !important;
  background: transparent !important;
  background-color: transparent !important;
}

@media (max-width: 768px) {
  .terminal-title,
  .command-line,
  .cmd-select ::v-deep .vs__selected {
    font-size: 1.2rem;
  }

  .command-line {
    flex-wrap: nowrap;
    white-space: nowrap;
  }

  .cmd-select,
  .cmd-select ::v-deep .vs__dropdown-toggle {
    width: 10.75rem;
    min-width: 0;
    max-width: 100%;
  }
}
</style>

<style lang="scss">
.disk-eq-menu {
  z-index: 100000 !important;
  margin-top: 4px;
  padding: 4px 0;
  background: #0e1116 !important;
  background-color: #0e1116 !important;
  border: 1px solid #3d4c63;
  border-radius: 0.35rem;
}

.disk-eq-menu .vs__dropdown-option {
  padding: 6px 10px;
  background: transparent !important;
  background-color: transparent !important;
  color: #e7eef8 !important;
  font-family: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 1.15rem;
  line-height: 1.3;
  white-space: nowrap;
}

.disk-eq-menu .vs__dropdown-option--highlight {
  background: #1a1f27 !important;
  background-color: #1a1f27 !important;
  color: #e7eef8 !important;
}
</style>
